"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableOffersToJSON = exports.AvailableOffersFromJSONTyped = exports.AvailableOffersFromJSON = exports.instanceOfAvailableOffers = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AvailableOffers interface.
 */
function instanceOfAvailableOffers(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAvailableOffers = instanceOfAvailableOffers;
function AvailableOffersFromJSON(json) {
    return AvailableOffersFromJSONTyped(json, false);
}
exports.AvailableOffersFromJSON = AvailableOffersFromJSON;
function AvailableOffersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'offerFulfillmentOrderId': !(0, runtime_1.exists)(json, 'offer_fulfillment_order_id') ? undefined : json['offer_fulfillment_order_id'],
        'expiry': !(0, runtime_1.exists)(json, 'expiry') ? undefined : (new Date(json['expiry'])),
        'totalOfferAmountMicros': !(0, runtime_1.exists)(json, 'total_offer_amount_micros') ? undefined : json['total_offer_amount_micros'],
        'remainingOfferAmountMicros': !(0, runtime_1.exists)(json, 'remaining_offer_amount_micros') ? undefined : json['remaining_offer_amount_micros'],
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
    };
}
exports.AvailableOffersFromJSONTyped = AvailableOffersFromJSONTyped;
function AvailableOffersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'offer_fulfillment_order_id': value.offerFulfillmentOrderId,
        'expiry': value.expiry === undefined ? undefined : (value.expiry.toISOString()),
        'total_offer_amount_micros': value.totalOfferAmountMicros,
        'remaining_offer_amount_micros': value.remainingOfferAmountMicros,
        'currency': value.currency,
    };
}
exports.AvailableOffersToJSON = AvailableOffersToJSON;
